import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import DualMultiSelect from "components/Forms/Elements/DualMultiSelect";
import isEmpty from "lodash/isEmpty";
import { getAllTeams } from "store/actions/teamAction";
import Notification from "components/Notification";
import ErrorLabel from "components/Forms/Elements/ErrorLabel";
import Translate from "helpers/Translate";

function Team({
  teamWorkflow,
  teamWorkflowsLength,
  ignoredTeams = [],
  clientId,
  onDeleteWorkflow,
  onTeamSelect,
  onTeamRemove,
  removeSucceedingWorkflows,
  errorWorkflow
}) {
  const dispatch = useDispatch();
  const teams = useSelector(state => state.team.getAllTeams);
  const [showTeamBox, setShowTeamBox] = useState(false);

  return (
    <div className="workflow my-30">
      {/* <!-- Column 1 --> */}
      <div className="col-1">
        <h2 className="title mb-20">{Translate({ id: "source_team" })} </h2>
        <div className="row">
          <div className="team-source-destination">
            <h3 className="team-name">{teamWorkflow.source_team.label}</h3>
          </div>
        </div>
      </div>

      {/* <!-- Column 2 --> */}
      <div className="col-2">
        <i className="fas fa-long-arrow-alt-right"></i>
      </div>

      {/* <!-- Column 3 --> */}
      <div className="col-3">
        <h2 className="title mb-20">
          {Translate({
            id: "select_any_one_team_that_will_be_responsible_to_review"
          })}
        </h2>
        <div className="team">
          <div className="form-group mb-10">
            {showTeamBox ? (
              <DualMultiSelect
                selectItemsLabel={Translate({ id: "select_a_team" })}
                selectedItemsLabel={Translate({ id: "selected_teams" })}
                placeholder={Translate({ id: "search_team_name" })}
                onSearch={e =>
                  dispatch(
                    getAllTeams({
                      clientId,
                      ignoreIds: ignoredTeams,
                      name: e.target.value
                    })
                  )
                }
                items={teams.data.map(t => ({ label: t.name, value: t.id }))}
                selectedItems={
                  isEmpty(teamWorkflow.destination_team)
                    ? []
                    : [teamWorkflow.destination_team]
                }
                onSearchReturnKey={() => {}}
                onSelect={item => {
                  if (teamWorkflow.order >= teamWorkflowsLength) {
                    onTeamSelect(item);
                    setShowTeamBox(false);
                    dispatch(
                      getAllTeams({
                        clientId,
                        ignoreIds: [...ignoredTeams, item.value]
                      })
                    );
                  } else {
                    Notification.confirm(
                      Translate({
                        id: "selecting_this_item_will_remove_any_succeeding_workflows_proceed"
                      }),
                      {
                        labelOk: Translate({ id: "yes", uppercase: true }),
                        labelCancel: Translate({ id: "np", uppercase: true }),
                        onOk: () => {
                          onTeamSelect(item);
                          setShowTeamBox(false);
                          removeSucceedingWorkflows(item);
                          dispatch(
                            getAllTeams({
                              clientId,
                              ignoreIds: [...ignoredTeams, item.value]
                            })
                          );
                        }
                      }
                    );
                  }
                }}
                onRemoveItem={uuidTeam => {
                  if (teamWorkflow.order >= teamWorkflowsLength) {
                    onTeamRemove(uuidTeam);
                  } else {
                    Notification.confirm(
                      Translate({
                        id: "changing_this_item_will_remove_any_succeeding_workflows_proceed"
                      }),
                      {
                        labelOk: Translate({ id: "yes", uppercase: true }),
                        labelCancel: Translate({ id: "no", uppercase: true }),
                        onOk: () => {
                          onTeamRemove(uuidTeam);
                          removeSucceedingWorkflows(uuidTeam);
                        }
                      }
                    );
                  }
                }}
                errors={
                  isEmpty(teamWorkflow.destination_team) ? errorWorkflow : {}
                }
                errorKey="workflows"
                allowMultiSelect={false}
              />
            ) : (
              <>
                <div className="team-source-destination">
                  {!isEmpty(teamWorkflow.destination_team) ? (
                    <span className="assigned">
                      {teamWorkflow.destination_team.label}
                      <div
                        className="change-team pointer mt-5"
                        onClick={() => {
                          if (teamWorkflow.order >= teamWorkflowsLength) {
                            setShowTeamBox(true);
                          } else {
                            Notification.confirm(
                              Translate({
                                id: "changing_this_item_will_remove_any_succeeding_workflows_proceed"
                              }),
                              {
                                labelOk: Translate({
                                  id: "yes",
                                  uppercase: true
                                }),
                                labelCancel: Translate({
                                  id: "no",
                                  uppercase: true
                                }),
                                onOk: () => {
                                  setShowTeamBox(true);
                                  removeSucceedingWorkflows(teamWorkflow);
                                }
                              }
                            );
                          }
                        }}
                      >
                        ({Translate({ id: "change" })})
                      </div>
                    </span>
                  ) : (
                    <span
                      className="assign pointer"
                      onClick={() => setShowTeamBox(true)}
                    >
                      {Translate({ id: "click_to_assign_a_team" })}
                    </span>
                  )}
                </div>
                <ErrorLabel
                  errorKey={"workflows"}
                  errors={
                    isEmpty(teamWorkflow.destination_team) ? errorWorkflow : {}
                  }
                />
              </>
            )}
          </div>
        </div>
      </div>

      <i
        title={Translate({ id: "remove_workflow" })}
        className="fas fa-trash pointer mx-20"
        onClick={() => {
          if (teamWorkflow.order >= teamWorkflowsLength) {
            Notification.confirm(
              Translate({
                id: "sure_to_remove"
              }),
              {
                labelOk: Translate({ id: "yes", uppercase: true }),
                labelCancel: Translate({ id: "no", uppercase: true }),
                onOk: () => {
                  onDeleteWorkflow();
                }
              }
            );
          } else {
            Notification.confirm(
              Translate({
                id: "this_will_remove_any_succeeding_workflows_proceed"
              }),
              {
                labelOk: Translate({ id: "yes", uppercase: true }),
                labelCancel: Translate({ id: "no", uppercase: true }),
                onOk: () => {
                  onDeleteWorkflow();
                }
              }
            );
          }
        }}
      ></i>
    </div>
  );
}

Team.propTypes = {
  errorWorkflow: PropTypes.object,
  removeSucceedingWorkflows: PropTypes.func
};

export default Team;
